module.exports = __webpack_public_path__ + "static/trip-pref.a8858af4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/PageHome/images/trip-pref.png
// module id = 184
// module chunks = 168707334958949